import { applyMiddleware, createStore, compose } from 'redux'
import { persistStore /* , persistReducer  */ } from 'redux-persist'
// import storage from 'redux-persist/lib/storage'
import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'
import promiseMiddleware from 'redux-promise-middleware'
import rootReducer from './rootReducer'

const middlewares = [promiseMiddleware, thunk]

if (process.NODE_ENV === 'development') {
  middlewares.push(createLogger())
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const enhancer = composeEnhancers(applyMiddleware(...middlewares))

/* A BIT BUGGY, DISABLED TEMPORARILY. Object too large!!! */
// const persistedReducer = persistReducer({ key: 'root', storage, blacklist: ['loading'] }, rootReducer)

export const store = createStore(/* persistedReducer */ rootReducer, undefined, enhancer)
export const persistor = persistStore(store)

window.store = store
